class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute("end-time"));
    this.dayElement = this.querySelector('[data-target="day"]');
    this.hourElement = this.querySelector('[data-target="hour"]');
    this.minuteElement = this.querySelector('[data-target="minute"]');
    this.secondElement = this.querySelector('[data-target="second"]');
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const milisecDiff = this.endTime - new Date();
    if (milisecDiff <= 0) {
      this.dayElement.textContent = "00";
      this.hourElement.textContent = "00";
      this.minuteElement.textContent = "00";
      this.secondElement.textContent = "00";
      clearInterval(this.interval);
      this.style.display = "none";
      return;
    }

    const dateDiff = new Date(milisecDiff);
    const days = Math.floor(milisecDiff / (1000 * 60 * 60 * 24));
    const hours = dateDiff.getUTCHours();
    const minutes = dateDiff.getUTCMinutes();
    const seconds = dateDiff.getUTCSeconds();

    this.dayElement.textContent = days.toString().padStart(2, "0");
    this.hourElement.textContent = hours.toString().padStart(2, "0");
    this.minuteElement.textContent = minutes.toString().padStart(2, "0");
    this.secondElement.textContent = seconds.toString().padStart(2, "0");
  }
}

customElements.define("countdown-timer", CountdownTimer);
